import { render, staticRenderFns } from "./CreatePurchaseDownPayment.vue?vue&type=template&id=7195bc96"
import script from "./CreatePurchaseDownPayment.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports